export interface MonthSeparatorProps {
  month: string
  year: number
}

/**
 * Разделитель месяцев
 */
export function MonthSeparator({ month, year }: MonthSeparatorProps) {
  const currentYear = new Date().getFullYear()
  const showYear = year !== currentYear

  return (
    <div className="px-4 py-2">
      <p className="text-xs font-medium text-gray-400 dark:text-gray-500 uppercase tracking-wide">
        {month}{showYear ? ` ${year}` : ''}
      </p>
    </div>
  )
}
